import React, { useEffect, useState, useRef } from 'react';
import './index.css';
import { useInView } from 'react-intersection-observer';
import LcIconLink from '../../Generic/LcIconLink';
import LcDropDown from '../../Generic/LcDropDown';
import SideModal from '../../Layout/SideModal/SideModal';
import Parse from 'html-react-parser';
import { OptionsTooltips } from '../../../models/OptionsTooltips';
import LcIcon from '../../Generic/LcIcon';
import TextTools from "../../../services/TextTools/TextTools";
import { Menu, MenuItem } from '@szhsin/react-menu';
import Modal from '../../Dialog/Modal'
import lengendWork from '../../../assets/images/legendawork.png'
import { Field } from "../../../models/Field";
import { Period } from "../../../models/Period";
import { escapeRegExp } from 'lodash';

//Campos do Filtro
interface FilterField {
    label: string,
    name: string,
    type: string,
    value?: string,
    options?: any[],
    show?: boolean,
}

//Objeto do Filtro
interface FilterData {
    fields: FilterField[],
    onChange: Function
}

interface Sort {
    column: string,
    direction: string
}

type FontSize = 'tiny' | 'small' | 'medium' | 'large' | 'big';

interface Props {
    loading?: boolean,
    rows: object[],
    rowClick?: {
        rowPointer: boolean,
        rowFunction: Function,
        rowSelected?: any,
        rowColumn?: Function
    },
    columns: object[],
    tootipPropeties?: {
        montaFields: Function,
        searchExpandedFields: Function,
        optionsProprities: OptionsTooltips
    },
    functions?: {
        icon: string,
        tooltip?: string,
        func: Function,
        disabled?: boolean
    }[],
    functionGeneric?: {
        id?: string;
        icon: string,
        iconDisabled?: {
            color: string,
            tooltip: string,
            disabled?: boolean
        },
        tooltip?: string,
        badge?: { number: number, status: string },
        func?: Function,
        disabled?: boolean,

        isSelection?: boolean,
        selection?: {
            contents: Period[],
            onChange: Function
        },

        isFilter?: boolean,
        isFilterCampo?: {
            isLoadingContents?: boolean,
            contents: Period[],
            onChange: Function,
            onChangePesquisa: Function,
            dropDownOptions?: Field[],
            onClickOption?: Function
        },
    }[],
    functionsRow?: {
        label: string,
        func: Function,
        disabled?: Function,
        hidden?: Function,

    }[],
    loadMore?: Function,
    size: number, //Tamanho total dos dados retornado pela API
    height?: string,
    fontSize?: FontSize,
    onSortChange?: Function,
    onSelectChange?: Function,
    onRadioChange?: Function,
    filter?: FilterData,
    status?: Function,
    manufacturerUpdatedAt?: string,
    linked?: boolean
    workSelection?: boolean,
    rowLinkClick?: boolean
}

const LcInfiniteTable: React.FC<Props> = (props) => {

    const { ref, inView } = useInView({});
    const [clientHeight, setClientHeight] = useState<number>(0);
    const [filter, setFilter] = useState<FilterField[] | undefined>(props.filter?.fields);
    const [asFilter, setAsFilter] = useState<boolean>(false);
    const [modalFilterVisible, setModalFilterVisible] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<object[]>([]);
    const [sort, setSort] = useState<Sort>();
    const [selection, setSelection] = useState<Period>();
    const [dropDown, setDropDown] = useState<boolean>(true);
    const [openModalLegenda, setOpenModalLegenda] = useState<boolean>(false);
    const [options, setOptions] = useState<Field[]>([])
    const [selectedRadioRows, setSelectedRadioRows] = useState<any[]>([]);
    const textTools = new TextTools();

    useEffect(() => {
        props.functionGeneric?.map(teste => {
            let selectedTemp = teste.isFilterCampo?.dropDownOptions;

            if (selectedTemp != undefined) setOptions(selectedTemp);
        })
    }, [])

    useEffect(() => {
        let el = document.getElementById('lcdti');
        let defaultRowHeight = 31;
        if (el) {
            let rows = Math.floor((el.clientHeight - 60) / defaultRowHeight);
            setClientHeight(rows)
            props.loadMore && props.loadMore(rows);
        }
    }, [document.getElementById('lcdti')])

    useEffect(() => {
        props.rows && props.rows.length > 0 && inView && props.loadMore &&
            props.loadMore();
    }, [inView])

    const templateMais: Period = {
        label: "mais",
        text: "mais",
        fields: [{
            name: "mais",
            value: "mais"
        }]
    };

    const handleFilterAdvanced = (event: any) => {
        event.preventDefault();

        setSelectedRows([]);

        let _filterAdvanced = Object.assign([], filter);
        let filterCount = 0;
        filter &&
            filter.map(f => {
                _filterAdvanced.find((l: FilterField) => l.name === event.target[f.name].name ? f.value = event.target[f.name].value : false)
                filterCount += event.target[f.name].value.length;
            })
        setAsFilter(filterCount > 0);
        props.filter?.onChange(_filterAdvanced, clientHeight);
        setModalFilterVisible(false);
    }

    const handleFilterClear = () => {
        setAsFilter(false);
        var _filter = filter?.map((f: any) => {
            return {
                ...f,
                value: ""
            }
        })
        props.filter?.onChange(_filter, clientHeight);
        //props.loadMore(clientHeight);
    }

    const handleSort = (column: string) => {
        if (!sort || sort.column !== column) {
            setSort({ column, direction: 'asc' });
        }
        else {
            setSort({ ...sort, direction: sort.direction === 'asc' ? 'desc' : 'asc' });
        }
    }

    useEffect(() => {
        if (props.onSortChange && sort) {
            props.onSortChange({ sort, size: clientHeight });
        }
    }, [sort])

    useEffect(() => {
        props.onSelectChange &&
            props.onSelectChange(selectedRows);
    }, [selectedRows])

    useEffect(() => {
        props.onRadioChange &&
            props.onRadioChange(selectedRadioRows);
    }, [selectedRadioRows]);

    const getStatusRow = (status: string) => {
        const statusMap: { [key: string]: string } = {
            'primary': '#141b4d',
            'secondary': '#1b3a7a',
            'danger': '#e64646',
            'success': '#a5bf3e',
            'warning': '#ffb800',
            'link': '#0580ce'
        };

        return statusMap[status] || status;
    };

    const onChangeSelection = (selection: Period) => {
        setSelection(selection);
        props.functionGeneric?.map(teste => {
            teste.selection?.onChange(selection);
        })
        // props.functionGeneric && props.functionGeneric.selection?.onChange(selection);
    }

    const onChangeSelectionFilter = (selection: Period) => {
        setSelection(selection);
        // setSearch(selection.label); 
        props.functionGeneric?.map(teste => {
            teste.isFilterCampo?.onChange(selection);
        })
    }

    const [search, setSearch] = useState<string>("");

    const clearValue = () => {
        setSearch("");
        setDropDown(!dropDown);
        props.functionGeneric?.map(teste => {
            teste.isFilterCampo?.onChangePesquisa("");
        })
    }

    const searchValue = (e: any) => {
        setSearch(e.target.value);
        props.functionGeneric?.map(teste => {
            teste.isFilterCampo?.onChangePesquisa(e.target.value);
        })
    }

    const handleClickOptions = (e: any) => {
        props.functionGeneric?.map(teste => {

            if (teste.isFilterCampo) {
                let selectedTemp = options;

                selectedTemp.map((x: Field) => {
                    if (x.name == e.name) x.value = !x.value;
                })

                setOptions([...selectedTemp]);
                teste.isFilterCampo?.onClickOption && teste.isFilterCampo?.onClickOption(selectedTemp);
            }
        })
    }

    const [selectedRowId, setSelectedRowId] = useState<any>();

    const handleHidden = (row: any, isOnSelectedRowsRadio: any) => {
        if (isOnSelectedRowsRadio && row.id == isOnSelectedRowsRadio.id) {
            return false;
        }
        else if (selectedRowId == undefined) {
            return true;
        }
        else if (row.id != selectedRowId) {
            return true;
        }
        else {
            return false;
        }
    }

    const searchInput = useRef<any>(null);

    useEffect(() => {
        if (dropDown == false) {
            searchInput.current.focus();
        }
        else {
            setSearch("");
        }
    }, [dropDown]);


    const handleRowClick = (row: any, iCol: number) => {
        if (props.rowClick) {
            // if (iCol != 0 && iCol != 5) {
            props.rowClick.rowFunction(row);
            props.rowClick.rowColumn && props.rowClick.rowColumn(iCol);
            // }
        }
    }

    const [mousePosition, setMousePosition] = useState<{ x: number, y: number }>({ x: 0, y: 0 });

    const handleMouseMove = (event: any, rowId: number) => {
        setMousePosition({ x: event.pageX, y: event.pageY });
        setSelectedRowId(rowId);
    }

    return (
        <div id="lcdti" className="lc-datatableinfinite" style={{ height: props.height || '100%' }}>

            <SideModal visible={modalFilterVisible} header="Filtro" onClose={() => { setModalFilterVisible(false) }}>
                {/* <form onSubmit={handleFilterAdvanced}>
                    {
                        props.filter &&
                        props.filter.fields.map((f, i) => {
                            return (
                                <div key={i}>
                                    {f.show != undefined && f.show == false ?
                                        <></>
                                        :
                                        <>
                                            {(f.type === 'select') ?
                                                <SelectField name={f.name} value={f.value} options={f.options} label={f.label} />
                                                :
                                                <InputField name={f.name} value={f.value} type={f.type} label={f.label} />
                                            }
                                        </>
                                    }
                                </div>
                            )
                        })
                    }
                    <div className="space-between">
                        <button id="8bda7e8c-2b4c-4466-9cd1-cff90fa38045" className="lc-button bg-primary" type="submit"> Filtrar </button>
                        <button id="a24f7945-b978-4f42-9fbf-956f44784958" className="lc-button" type="reset" onClick={() => handleFilterClear()}> Limpar </button>
                    </div>
                </form> */}
            </SideModal>

            <div className="topbar">
                <div className="functions">
                    {
                        props.functions &&
                        <>
                            {
                                props.functions.map((func, index) => {
                                    return <LcIconLink
                                        tooltipPosition={index === 0 ? 'right' : undefined}
                                        disabled={func.disabled || false}
                                        key={index}
                                        icon={func.icon}
                                        tooltip={func.tooltip}
                                        onClick={() => { func.func(selectedRows) }} />
                                })
                            }
                        </>
                    }
                    {
                        props.functionGeneric &&
                        <div>
                            {
                                props.functionGeneric.map((func, index) => {
                                    if (func.isSelection) {
                                        let count = 0;

                                        return (
                                            <>
                                                {
                                                    <LcDropDown element={<span className="select-period"> <LcIconLink icon={func.icon} size="small" tooltip={func.tooltip} /> </span>}>
                                                        {
                                                            func.selection?.contents && func.selection?.contents.length > 0
                                                                ? <>
                                                                    {
                                                                        func.selection?.contents.map((p, i) => {
                                                                            count++;
                                                                            if (count <= 7) {
                                                                                return <span key={i} className="item" onClick={() => onChangeSelection(p)}>{p.label}</span>
                                                                            }
                                                                        })
                                                                    }
                                                                    <>
                                                                        <hr />
                                                                        <span
                                                                            className="item"
                                                                            // onClick={() => onChangeSelection(templateMais)} 
                                                                            style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}
                                                                        >
                                                                            Mais modelos
                                                                            <LcIconLink icon={"ppi ppi-chevron-right"} size={"small"} />
                                                                        </span>
                                                                    </>
                                                                </>
                                                                :
                                                                <span className="item"> Sem templates salvos </span>
                                                        }
                                                    </LcDropDown>
                                                }
                                            </>
                                        )
                                    }
                                    if (func.isFilter) {
                                        let count = 0;

                                        return (
                                            <>
                                                <LcIconLink icon={"ppi ppi-search"} onClick={() => setDropDown(!dropDown)} color={(!dropDown) ? "blue" : ""} activedAfterClick={(!dropDown) ? true : false} />
                                                <div hidden={dropDown} >
                                                    <div style={{ marginBottom: "-30px" }}>
                                                        <LcDropDown
                                                            width={"30vw"}
                                                            element={
                                                                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                                                    <input
                                                                        type="text"
                                                                        className={"searchTextLcInfinite"}
                                                                        ref={searchInput}
                                                                        onChange={searchValue}
                                                                        value={search.replace("> ", "")}
                                                                        autoComplete='false'
                                                                        onKeyPress={(event) => { if (event.key === "Enter") onChangeSelectionFilter(templateMais) }}
                                                                    />
                                                                    <LcIconLink icon={"ppi ppi-x"} tooltip="Fechar" size='small' onClick={() => clearValue()} />
                                                                </div>
                                                            }
                                                            onEnterClose={true}
                                                            trigger={"keyPress"}
                                                        >
                                                            {
                                                                func.isFilterCampo?.isLoadingContents
                                                                    ? <span className="item">Carregando...</span>
                                                                    : <>
                                                                        {
                                                                            func.isFilterCampo?.contents.map((p, i) => {

                                                                                count++;

                                                                                var result_ = '';

                                                                                if (typeof p.label === 'string' && typeof search === 'string') {
                                                                                    var searchMask = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                                                                                    searchMask = escapeRegExp(searchMask);
                                                                                    var regEx = new RegExp(searchMask, "ig");
                                                                                    var replaceMask = `<b>${searchMask}</b>`;

                                                                                    result_ = p.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(regEx, replaceMask);
                                                                                    result_ = textTools.cleanTagEmailParse(result_);
                                                                                }

                                                                                return (
                                                                                    <span key={i} className="item" onClick={() => onChangeSelectionFilter(p)}>
                                                                                        {Parse(result_)}
                                                                                    </span>
                                                                                )
                                                                            })
                                                                        }
                                                                    </>
                                                            }
                                                        </LcDropDown>

                                                        {
                                                            func.isFilterCampo?.dropDownOptions &&
                                                            <LcDropDown trigger='click' element={<LcIconLink icon={"ppi ppi-chevron-down"} size={"small"} />} width={"250px"} hold={true}>
                                                                {
                                                                    options.map((option) => {

                                                                        return (
                                                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyItems: "center" }}>
                                                                                <input type="checkbox" style={{ float: "left", marginRight: "10px" }} onClick={() => handleClickOptions(option)} checked={(option.value == true) ? true : false} />
                                                                                <span className="item" style={{ marginTop: "5px" }}> {option.label} </span>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </LcDropDown>
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }

                                    if (func.iconDisabled) {
                                        if (func.iconDisabled.disabled && func.iconDisabled.disabled == true) {
                                            return <LcIcon
                                                id={func.id}
                                                icon={func.icon}
                                                tooltipPosition={index === 0 ? 'right' : undefined}
                                                key={index}
                                                tooltip={func.iconDisabled.tooltip}
                                                color={func.iconDisabled.color} />
                                        }
                                        else {
                                            if ((selectedRadioRows && selectedRadioRows.length > 0) || (props.rowClick && props.rowClick.rowSelected)) {

                                                return <LcIconLink
                                                    id={func.id}
                                                    tooltipPosition={index === 0 ? 'right' : undefined}
                                                    key={index}
                                                    icon={func.icon}
                                                    tooltip={func.tooltip}
                                                    onClick={func.func} />
                                            }
                                            else {

                                                return <LcIcon
                                                    id={func.id}
                                                    icon={func.icon}
                                                    tooltipPosition={index === 0 ? 'right' : undefined}
                                                    key={index}
                                                    tooltip={func.iconDisabled.tooltip}
                                                    color={func.iconDisabled.color} />
                                            }
                                        }
                                    }
                                    else {

                                        return <LcIconLink
                                            id={func.id}
                                            tooltipPosition={index === 0 ? 'right' : undefined}
                                            key={index}
                                            icon={func.icon}
                                            tooltip={func.tooltip}
                                            onClick={func.func} />
                                    }
                                })
                            }
                        </div>

                    }
                    {/* {
                        <div>
                            <i className="ppi ppi-plus-sm" />    
                        </div>
                    }
                    {
                        <div>
                            <i className="ppi ppi-duplicate" />    
                        </div>
                    }
                    {
                        props.filter &&
                        <div>
                            <LcIconLink
                                icon={`ppi ppi-filter ${asFilter ? 'text-warning' : ''}`}
                                onClick={() => { setModalFilterVisible(true) }}
                                tooltip="Filtro" />
                        </div>
                    } */}
                    {
                        props.workSelection &&
                        <>
                            <Menu menuButton={
                                <div className='lciconlink big' style={{ paddingLeft: '8px' }}>
                                    <i className={"ppi ppi-dots-vertical"} />
                                </div>}>
                                <MenuItem
                                    onClick={() => setOpenModalLegenda(true)}
                                    style={{ fontFamily: "Inter" }}
                                >
                                    <p style={{ fontSize: '14px', color: '#2B304F', borderRadius: '8px' }}>Legenda</p>
                                </MenuItem>
                            </Menu>

                            <Modal width='100vw' visible={openModalLegenda} title='Como entender um trabalho Hey!ho!' close={() => setOpenModalLegenda(false)}>
                                <div className='form' style={{ justifyContent: 'center' }}>
                                    <img src={lengendWork} />
                                </div>
                            </Modal>
                        </>
                    }

                </div>
                <div className="pagination">
                    {/* {
                        props.manufacturerUpdatedAt &&
                        <p className="manufacturerupdatedat">A última atualização do provedor para esta informação foi em {props.manufacturerUpdatedAt}</p>
                    }
                    {
                        props.onSelectChange &&
                        <div className="pageinfo">
                            {selectedRows.length} linha{selectedRows.length === 1 ? '' : 's'} selecionadas
                        </div>
                    }
                    <span className="pageinfo">
                        {props.rows && props.rows.length} de {props.size}
                    </span> */}
                </div>
            </div>

            <div className="header">
                {
                    props.onSelectChange &&
                    <div className="selectable" >
                        <i
                            className={`ppi ppi-checkbox${(selectedRows.length > 0) ? '-on text-warning' : ' text-grey'}`}
                            onClick={() => {
                                (selectedRows.length > 0)
                                    ? setSelectedRows([])
                                    : setSelectedRows(props.rows)
                            }} />
                    </div>
                }
                {
                    props.columns.map((c: any, i: number) => {
                        return c.hide !== true && (
                            <div
                                className={`cell ${(props.onSortChange && c.sort !== false) ? 'sortable' : ''} ${(sort?.column === c.field) ? 'text-link' : ''}${c.align || ''}`}
                                style={{ width: c.width }}
                                key={i}
                                onClick={() => { c.sort !== false && props.onSortChange && handleSort(c.field) }}
                            >
                                <span> {(c.field === "statusIcon") ? "" : c.headerName} </span>
                                {
                                    c.headerName && sort && sort.column === c.field &&
                                    <i className={`ppi ppi-arrow-${(sort.direction === 'asc') ? 'down' : 'up'}`} />
                                }
                            </div>
                        )
                    })
                }
                {
                    props.functionsRow &&
                    <div className="cell" />
                }
            </div>

            <div className="body">
                {
                    props.rows &&
                    props.rows.map((row: any, iRow: number,) => {

                        return (
                            <div className="row" key={iRow}>
                                <div className="status" style={{ backgroundColor: props.status && getStatusRow(props.status(row)) }} />
                                {
                                    (() => {
                                        let isOnSelectedRows = selectedRows.find((r: any) => { return r.id === row.id });

                                        if (props.onSelectChange) {
                                            return (
                                                <div
                                                    className="selectable"
                                                    onClick={() => {
                                                        isOnSelectedRows
                                                            ? setSelectedRows(selectedRows.filter((r: any) => r.id !== row.id))
                                                            : setSelectedRows([...selectedRows, row])
                                                    }}>
                                                    <i className={`ppi ppi-checkbox${isOnSelectedRows ? '-on text-warning' : ' text-grey'}`} />
                                                </div>
                                            )
                                        }
                                    })()
                                }

                                <a className={`cells`}
                                    href={(props.rowLinkClick) ? `/Attendance/${row.id}` : undefined}
                                    style={{ textDecoration: 'none', color: 'black' }}
                                >
                                    {
                                        props.columns.map((col: any, iCol: number) => {
                                            return !col.hide && (
                                                <div key={iCol}
                                                    className={`cell ${props.fontSize || ''} ${col.align || ''}`}
                                                    style={{
                                                        width: col.width,
                                                        height: "100%",
                                                        overflow: col.overflow,
                                                        cursor: (props.rowClick || props.rowLinkClick) ? "pointer" : "auto"
                                                    }}
                                                    onClick={() => handleRowClick(row, iCol)}
                                                >
                                                    {
                                                        !col.renderCell
                                                            ? <>{row[col.field]}</>
                                                            : (props.linked) ? col.renderCell(row, props.linked) : col.renderCell(row)
                                                    }
                                                </div>

                                            )
                                        })
                                    }
                                </a>

                                <div className="functions">
                                    {
                                        props.functionsRow &&
                                        <LcDropDown element={<LcIconLink icon="ppi ppi-dots-vertical" size="small" />} position="right">
                                            {
                                                props.functionsRow.map((f, i) => {
                                                    if (!f.hidden || !f.hidden(row)) {
                                                        let disabled = (f.disabled && f.disabled(row)) || false;
                                                        return (
                                                            <div
                                                                key={i}
                                                                className={`item${disabled ? ' disabled' : ''}`}
                                                                onClick={() => { !disabled && f.func(row) }}> {f.label} </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </LcDropDown>
                                    }
                                </div>
                            </div>
                        )
                    })
                }

                {
                    props.loading &&
                    <div className="loader">
                        <i className="ppi ppi-refresh text-warning" />&nbsp;Carregando...
                    </div>
                }

                {
                    props.size > clientHeight && (props.rows && props.rows.length < props.size) &&
                    <div className="loader">
                        <div ref={ref}>
                            {
                                !inView
                                    ? <><i className="ppi ppi-refresh text-warning" /> &nbsp;Carregando... </>
                                    : <></>
                                // <i className="ppi ppi-dots-horizontal" />
                            }
                        </div>
                    </div>
                }
                {
                    !props.loading && (!props.rows || (props.rows && props.rows.length == 0)) &&
                    <div className="centralized">
                        <span> <i className="ppi ppi-exclamation text-warning" />
                            <h3 className='noLinesAttendance' style={{ display: 'inline-block', transform: 'translateY(-30px)', translate: '20px 0' }}>Nenhuma linha encontrada</h3>
                        </span>
                    </div>
                }
            </div>
        </div>
    );
}

export default LcInfiniteTable;